var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[(_vm.show_loading)?_c('Loading'):_c('div',[_c('WrapperListView',{attrs:{"dataWrapperList":_vm.dataWrappers,"listItemComponent":_vm.listItemComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }